import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Nav from '../../components/smart/Nav';
import PrivateRoute from '../PrivateRoute';
import { useSelector } from 'react-redux';

const ProjectManagerRoute = ({ component: Component, ...rest }) => {

    const userID = useSelector(state => state.session.userID);
    const userRole = useSelector(state => state.user.users[userID]?.role);

    if(userRole == "contractor") return <Redirect to="/C"/>

    return (
        <Route {...rest} render={props => (
            <React.Fragment>
                <Nav />
                <PrivateRoute component={Component} />
            </React.Fragment>
        )} />
    );
}

export default ProjectManagerRoute;